import styled from 'styled-components';

export const UiDropContainer = styled.div`
`;

export const UiDropItem = styled.div`
`;
